<template>
  <transition
    :name="!index || index === 0 ? 'fade-slide' : `fade-slide-${index + 1}`"
    appear
  >
    <div :class="[$style.base, { [$style.smallScreen]: $screen === 's' }]">
      <BaseCard>
        <Flex
          :gap="1"
          :direction="$screen === 's' ? 'column' : 'row'"
          :align="$screen === 's' ? 'start' : 'center'"
          justify="between"
          :wrap="$screen !== 's'"
        >
          <Flex
            :align="$screen === 'l' ? 'center' : 'start'"
            :class="$style.left"
          >
            <img
              :src="image"
              :class="$style.image"
            >
            <Flex direction="column">
              <Flex
                :gap="0.5"
                direction="column"
              >
                <BaseHeading>{{ heading }}</BaseHeading>
                <BaseText size="s">{{ description }}</BaseText>
              </Flex>
              <slot name="extraContent" />
            </Flex>
          </Flex>
          <Flex
            direction="column"
            :gap="0.5"
            justify="end"
            :class="$style.right"
          >
            <slot name="tasks" />
          </Flex>
        </Flex>
      </BaseCard>
    </div>
  </transition>
</template>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  index?: number;
  image: string;
  heading: string;
  description: string;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  width: 100%;
}

.left {
  .base.smallScreen & {
    width: 100%;
  }

  .base:not(.smallScreen) & {
    flex: 1 1 400px;
    min-width: 0;
  }
}

.right {
  max-width: 350px;
  width: 100%;

  .base:not(.smallScreen) & {
    flex: 1 1 300px;
  }
}

.image {
  object-fit: contain;
  width: 160px;
  flex-shrink: 0;

  .base.smallScreen & {
    width: 80px;
    margin: auto 0;
  }
}
</style>
